const interval = setInterval(() => {
    const widget = document.querySelector('#yotpo-reviews-star-ratings-widget');
    const button = widget?.querySelector('button');

    if (widget && button) {
      button.addEventListener('click', () => {
        const target = document.getElementById('jumpToReviews');
        if (target) {
          const offset = window.innerHeight * 0.1;
          const elementPosition = target.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - offset;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
      });

      clearInterval(interval); 
    }
  }, 500); 